module.exports = "../../../../platform/assets/pageMainIcon/business_yewushezhilei5.svg";